"use client";

import { StateCreator } from "zustand";
import {
  Surgery,
  UploadResponseUpload,
} from "@clients/velys-infrastructure/api";

export type CaseInfoState = {
  procedureType: string;
  searchValue: string;
  location: string;
  surgeon: string;
  cases: {
    TKA: Surgery[];
    UKA: Surgery[];
  };
  casesCursor: string | undefined;
  uploadProgress: number;
  caseUploadStatus: UploadResponseUpload | null;
  caseUploadLocation: string;
  surgery: Surgery | null;

  // Actions
  setProcedureType: (dataType: string) => void;
  setSearchValue: (searchValue: string) => void;
  setLocation: (location: string) => void;
  setSurgeon: (surgeon: string) => void;
  setCases: (type: string, cases: Surgery[]) => void;
  setCasesCursor: (cursor: string | undefined) => void;
  setUploadProgress: (percent: number) => void;
  setCaseUploadStatus: (status: UploadResponseUpload | null) => void;
  setSurgery: (surgery: Surgery | null) => void;
  setCaseUploadLocation: (location: string) => void;
  downloadPatientCSV: (url?: string | null, filename?: string) => void;
  downloadPatientPDF: (pdf?: string[] | null) => void;
  downloadProcedureImages: (imgs?: string[] | null, filename?: string) => void;
};

// states used on monthly page
export const createCaseInfoSlice: StateCreator<CaseInfoState> = (set) => ({
  procedureType: "TKA",
  searchValue: "",
  location: "all",
  surgeon: "all",
  cases: {
    TKA: [],
    UKA: [],
  },
  casesCursor: undefined,
  uploadProgress: 0,
  caseUploadStatus: null,
  caseUploadLocation: "",
  surgery: null,

  // Actions
  setProcedureType: (dataType) => set({ procedureType: dataType }),
  setSearchValue: (searchValue) => set({ searchValue }),
  setLocation: (location) => set({ location }),
  setSurgeon: (surgeon) => set({ surgeon }),
  setCases: (procedureType: string, patients: Surgery[]) =>
    set((state) => ({
      cases: {
        ...state.cases,
        [procedureType]: patients,
      },
    })),
  setCasesCursor: (casesCursor) => set({ casesCursor }),
  setUploadProgress: (percent) => set({ uploadProgress: percent }),
  setCaseUploadStatus: (caseUploadStatus) => set({ caseUploadStatus }),
  setSurgery: (surgery) => set({ surgery }),
  setCaseUploadLocation: (location: string) =>
    set({ caseUploadLocation: location }),
  downloadPatientCSV: (url, filename = "patient.csv") => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  downloadPatientPDF: (pdfs) => {
    if (pdfs && pdfs.length > 0) {
      pdfs.forEach((link, idx) => {
        setTimeout(() => {
          const a = document.createElement("a");
          a.href = link;
          a.download = `pdf-${idx}`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }, idx * 1000);
      });
    }
    return;
  },
  downloadProcedureImages: (imgs, filename) => {
    if (imgs && imgs.length > 0) {
      imgs.forEach((link, idx) => {
        setTimeout(() => {
          const a = document.createElement("a");
          a.href = link;
          a.download = filename || "";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }, idx * 1000);
      });
    }
    return;
  },
});
